import { render, staticRenderFns } from "./EditOption.vue?vue&type=template&id=1a95f073&scoped=true&"
import script from "./EditOption.vue?vue&type=script&lang=js&"
export * from "./EditOption.vue?vue&type=script&lang=js&"
import style0 from "./EditOption.vue?vue&type=style&index=0&id=1a95f073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95f073",
  null
  
)

export default component.exports